<template>
	<div class="index">
		<div class="course" v-if="hintFlag">
			<div class="fixation">
				<div class="block">
					<div class="block-title">
						拍卖指南
					</div>
					<div class="block-list">
						<li v-for="(item,index) in course" :key="index">
							<router-link :to="{path:'/essay',query:{id:item.articleId, category:'拍卖指南'}}">
								<span>新</span>
								{{item.articleName}}
							</router-link>
						</li>
					</div>
					<div class="block-more">
						<router-link to="">
							查看更多>>
						</router-link>
					</div>
				</div>
				<div class="block">
					<div class="block-title">
						竞拍流程
					</div>
					<div class="block-list">
						<div class="step" v-for="(item,index) in step" :key="index">
							<div class="step-index">
								<img :src="item.icon" alt="">
							</div>
							<div class="step-mid">
								<div class="step-key">
									{{item.key}}
								</div>
								<div class="step-value">
									{{item.value}}
								</div>
							</div>
							<div class="step-arrow" v-if="index<5">
								<img src="../../../assets/arrow.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="close" @click="closeHint">
					<span>
						不再提示
						<i class="el-icon-close"></i>
					</span>
				</div>
			</div>
		</div>
		<div class="laws">
			<div class="fixation">
				<div class="laws-left">
					<div class="laws-title">
						<div>
							网拍法规
							<img src="../../../assets/judge.png" alt="">
						</div>
						<div>
							<router-link to="/paper">
								更多
							</router-link>
						</div>
					</div>
					<ul>
						<li v-for="(item,index) in laws" :key="index">
							<router-link :to="{path:'/essay',query:{id:item.articleId, category:'网拍法规'}}">
								{{item.articleName}}
							</router-link>
						</li>
					</ul>
				</div>
				<div class="laws-mid">
					<router-link to="/scene">
						<img src="../../../assets/laws-2.png" alt="">
					</router-link>
				</div>
				<div class="laws-right">
					<router-link to="/one">
						<img src="../../../assets/laws-4.jpg" alt="">
					</router-link>
				</div>
			</div>
		</div>
		<div class="commodity">
			<div class="fixation">
				<div class="title">
					<div>
						<img src="../../../assets/preview.png" alt="">
					</div>
					<div>
						<router-link to="/advance">
							查看更多
							<i class="el-icon-arrow-right"></i>
						</router-link>
					</div>
				</div>
				<div class="empty" v-show="previewList.length == 0">
					<el-empty description="当前暂无数据"></el-empty>
				</div>
				<div class="block">
					<div class="block-title"></div>
					<div class="commodity-block">
						<commodity v-for="(item,index) in previewList" :key="index" :node="item"></commodity>
					</div>
				</div>
			</div>
		</div>
		<div class="commodity">
			<div class="fixation">
				<div class="title">
					<div>
						<img src="../../../assets/today.png" alt="">
					</div>
					<div>
						<span v-for="(item,index) in times" :key="index">{{item}}</span>
						次围观
					</div>
				</div>
				<div class="empty" v-show="commodity.length == 0">
					<el-empty description="当前暂无数据"></el-empty>
				</div>
				<div class="block" v-for="(item,index) in commodity" :key="index" v-show="item['tabs'].length>0">
					<div class="block-title">
						<div>
							{{item.title}}
						</div>
						<div>
							<router-link to="">
								更多
								<span>{{item.more}}</span>
								件
								<i class="el-icon-arrow-right"></i>
							</router-link>
						</div>
					</div>
					<div class="commodity-block">
						<commodity v-for="(tab,tabIndex) in item['tabs']" :key="tabIndex" :node="tab"></commodity>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				course: [],
				step: [{
						icon: require('../../../assets/step-1.png'),
						key: '阅读公告',
						value: '注意竞买要求及相关约定'
					},
					{
						icon: require('../../../assets/step-2.png'),
						key: '联系处置方',
						value: '未尽事宜咨询处置方'
					},
					{
						icon: require('../../../assets/step-3.png'),
						key: '交保证金',
						value: '确认提交成功'
					},
					{
						icon: require('../../../assets/step-4.png'),
						key: '开始竞价',
						value: '注意开拍时间'
					},
					{
						icon: require('../../../assets/step-5.png'),
						key: '竞价成功',
						value: '价高者得'
					},
					{
						icon: require('../../../assets/step-6.png'),
						key: '线下付款交割',
						value: '联系处置方确认相关流程'
					}
				],
				laws: [],
				times: [],
				commodity: [],
				hintFlag: true,
				previewList: []
			};
		},
		methods: {
			fetchCategory() {
				this.$api.frontCategory({}, res => {
					if (res.code == 200) {
						let list = res.data
						let array = new Array()
						let times = 0
						for (let i = 0; i < list.length; i++) {
							this.$api.frontCommodityToday({
								pageSize: 8,
								pageNum: 1,
								lotOneType: list[i]['id']
							}, result => {
								if (result.code == 200) {
									times += result.data[0]
									this.times = (times + '').split('')
									let flow = new Array()
									let series = result.data[1].list
									for (let k = 0; k < series.length; k++) {
										let diff = this.$pub.timeStampDifferene(series[k]['endTime'])
										let node = {
											image: series[k]['lotPictrueUrl'],
											name: series[k]['lotName'],
											now: !series[k]['currentPrice'] ? series[k]['startPrice'] :
												series[k]['currentPrice'],
											number: !series[k]['biddingCount'] ? 0 : series[k][
												'biddingCount'
											],
											evaluated: series[k]['evaluationPrice'],
											day: diff.day,
											timeStr: diff.h + ':' + diff.m + ':' + diff.s,
											view: !series[k]['watchFrequency'] ? 0 : series[k][
												'watchFrequency'
											],
											people: !series[k]['enrollNumber'] ? 0 : series[k][
												'enrollNumber'
											],
											status: series[k]['auctionStatus'],
											id: series[k]['id'],
										}
										flow.push(node)
									}
									let obj = {
										title: list[i]['name'],
										more: result.data[1].total,
										tabs: flow
									}
									if(flow.length>0){
										array.push(obj)
									}
									this.commodity = array
								}
							})
						}
					}
				})
			},
			fetchArticle() {
				this.$api.frontArticleList({
					pageSize: 6,
					pageNum: 1,
					articleOneType: 1
				}, res => {
					if (res.code == 200) {
						this.course = res.data.list
					}
				})
				this.$api.frontArticleList({
					pageSize: 6,
					pageNum: 1,
					articleOneType: 2
				}, res => {
					if (res.code == 200) {
						this.laws = res.data.list
					}
				})
			},
			closeHint() {
				this.hintFlag = false
				sessionStorage.setItem('hintFlag', 1)
			},
			fetchPerviewList() {
				this.$api.frontCommodityList({
					auctionStatus: 1,
					endDate: "",
					lotName: "",
					lotOneType: "",
					lotTwoType: "",
					pageNum: 1,
					pageSize: 4,
					startDate: ""
				}, res => {
					if (res.code == 200) {
						let list = res.data.list
						let array = new Array()
						for (let i = 0; i < list.length; i++) {
							let transTime = ''
							if (list[i].auctionStatus == 1) {
								transTime = list[i]['startTime']
							} else {
								transTime = list[i]['endTime']
							}
							let diff = this.$pub.timeStampDifferene(transTime)
							let obj = {
								image: list[i]['lotPictrueUrl'],
								name: list[i]['lotName'],
								now: !list[i]['currentPrice'] ? list[i]['startPrice'] : list[i][
									'currentPrice'
								],
								number: !list[i]['biddingCount'] ? 0 : list[i][
									'biddingCount'
								],
								evaluated: list[i]['evaluationPrice'],
								day: diff.day,
								timeStr: diff.h + ':' + diff.m + ':' + diff.s,
								view: !list[i]['watchFrequency'] ? 0 : list[i][
									'watchFrequency'
								],
								people: !list[i]['enrollNumber'] ? 0 : list[i][
									'enrollNumber'
								],
								status: parseInt(list[i]['auctionStatus']),
								start: list[i]['startPrice'],
								id: list[i]['id'],
								tag: list[i]['lotLabel'].split(',')
							}
							array.push(obj)
						}
						this.previewList = array
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.hintFlag = !sessionStorage.getItem('hintFlag')
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchCategory()
			this.fetchArticle()
			this.fetchPerviewList()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.index {
		width: 100%;
		background: @vue-bg-color-grey;
		padding: @vue-spacing-col-lg 0px;

		.course {
			width: 100%;

			.fixation {
				background: @vue-bg-color;
				position: relative;

				.close {
					width: 30px;
					height: 120px;
					position: absolute;
					right: -31px;
					top: 20px;
					background: @vue-bg-color;
					border-left: 1px solid @vue-border-color;
					display: flex;
					flex-direction: column;
					justify-content: center;
					font-size: @vue-font-size-sm - 2;
					padding-left: 8px;
					box-sizing: border-box;
					cursor: pointer;
				}

				.close:hover {
					color: @vue-text-color-active;
				}

				.block {
					width: 100%;
					height: 90px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid @vue-border-color;

					.block-title {
						width: 80px;
						height: 55px;
						text-align: center;
						vertical-align: middle;
						font-size: @vue-font-size-sm + 4;
						border-right: 1px solid @vue-border-color;
						padding: 0px @vue-spacing-row-sm;
						box-sizing: border-box;
					}

					.block-more {
						width: 100px;
						height: 55px;
						display: flex;
						align-items: center;
						justify-content: center;
						border-left: 1px solid @vue-border-color;
						box-sizing: border-box;

						a,
						span {
							font-size: @vue-font-size-sm - 2;
							color: @vue-text-color;
							cursor: pointer;
						}

						a:hover,
						span:hover {
							color: @vue-text-color-active;
						}
					}

					.block-list {
						height: 100%;
						display: flex;
						flex-wrap: wrap;
						padding: 15px 0px;
						box-sizing: border-box;

						li {
							width: 33.3%;
							height: 50%;

							a {
								width: 100%;
								height: 100%;
								line-height: 30px;
								overflow: hidden;
								text-overflow: ellipsis;
								padding-left: @vue-spacing-row-base;
								box-sizing: border-box;
								font-size: @vue-font-size-sm - 2;
								color: @vue-text-color;

								span {
									background: @vue-bg-color-red;
									color: @vue-text-color-inverse;
									padding: 3px;
								}
							}

							a:hover {
								color: @vue-text-color-active;
							}
						}

						.step {
							height: 100%;
							display: flex;
							justify-content: space-between;
							align-items: center;

							.step-index {
								width: 50px;
								display: flex;
								align-items: center;
								justify-content: center;
							}

							.step-mid {

								.step-key,
								.step-value {
									width: 100%;
									height: 30px;
									display: flex;
									align-items: center;
								}

								.step-key {
									font-size: @vue-font-size-sm - 2;
									font-weight: bold;
								}

								.step-value {
									font-size: @vue-font-size-min;
								}
							}

							.step-arrow {
								width: 40px;
								height: 40px;

								img {
									width: 100%;
									height: 100%;
								}
							}
						}
					}
				}

				.block:first-child {
					.block-list {
						width: calc(100% - 180px);
					}
				}

				.block:nth-child(2) {
					.block-list {
						width: calc(100% - 90px);
					}
				}
			}
		}

		.laws {
			width: 100%;
			height: 166px;
			margin-top: @vue-spacing-col-lg;

			.fixation {
				display: flex;
				justify-content: space-between;

				.laws-left {
					width: 240px;
					height: 100%;
					background: #eeeeee;
					padding: 0px @vue-spacing-row-base;
					box-sizing: border-box;

					.laws-title {
						width: 100%;
						height: 40px;
						display: flex;
						justify-content: space-between;

						div {
							height: 100%;
							display: flex;
							align-items: center;
							font-size: @vue-font-size-sm - 2;

							img {
								width: 16px;
								height: 16px;
								margin-left: 4px;
							}

							a {
								color: @vue-text-color;
							}

							a:hover {
								color: @vue-text-color-active;
							}
						}
					}

					ul {
						width: 100%;
						height: calc(100% - 40px);
						overflow: hidden;

						li {
							width: 100%;
							height: 33%;

							a {
								width: 100%;
								height: 100%;
								display: block;
								line-height: 36px;
								overflow: hidden;
								text-overflow: ellipsis;
								font-size: @vue-font-size-min;
								color: @vue-text-color;
							}

							a:hover {
								color: @vue-text-color-active;
							}
						}
					}
				}

				.laws-mid,
				.laws-right {
					width: 460px;
					height: 100%;

					a,
					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		.commodity {
			width: 100%;
			margin-top: @vue-spacing-col-lg;

			.title {
				width: 100%;
				height: 60px;
				border-bottom: 2px solid @vue-text-color-red;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;

				div {
					height: 100%;
					display: flex;
					align-items: center;
					color: @vue-text-color-red;

					span {
						padding: 5px 5px;
						background: @vue-bg-color-red;
						color: @vue-text-color-inverse;
						margin-right: @vue-spacing-row-sm / 2;
					}
				}

				div:last-child {
					a {
						color: @vue-text-color-red;
					}
				}
			}

			.block {
				width: 100%;

				.block-title {
					width: 100%;
					height: 50px;
					display: flex;
					justify-content: space-between;

					div {
						height: 100%;
						display: flex;
						align-items: center;

						a {
							color: @vue-text-color;
							font-size: @vue-font-size-sm - 2;

							span {
								color: @vue-text-color-red;
								font-size: @vue-font-size-sm + 2;
							}
						}
					}
				}
			}
		}
	}
</style>
